import { Component, Inject, OnInit } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { Observable } from 'rxjs'
import { StaticLayerConfig } from '../../../../state/viewer/viewer.state'

export interface LayerListDialogData {
    title: string
    availableLayers$: Observable<StaticLayerConfig[]>
    currentSelection: StaticLayerConfig[]
}

const MAX_LAYERS = 5

@Component({
    selector: 'app-layer-list-dialog',
    templateUrl: './layer-list-dialog.component.html',
    styleUrls: ['./layer-list-dialog.component.scss'],
})
export class LayerListDialogComponent implements OnInit {
    availableLayers: StaticLayerConfig[] = []
    selectedLayers: StaticLayerConfig[] = []
    searchQuery = ''
    readonly maxLayers = MAX_LAYERS

    constructor(
        private readonly dialogRef: DialogRef<StaticLayerConfig[] | null>,
        @Inject(DIALOG_DATA) readonly data: LayerListDialogData
    ) {}

    ngOnInit(): void {
        this.selectedLayers = [...this.data.currentSelection]
        this.data.availableLayers$.subscribe(layers => {
            this.availableLayers = layers ?? []
        })
    }

    toggleLayer(layer: StaticLayerConfig): void {
        const index = this.selectedLayers.findIndex(l => l.name === layer.name)
        if (index >= 0) {
            this.selectedLayers.splice(index, 1)
        } else if (this.selectedLayers.length < this.maxLayers) {
            this.selectedLayers.push(layer)
        }
    }

    isLayerSelected(layer: StaticLayerConfig): boolean {
        return this.selectedLayers.some(l => l.name === layer.name)
    }

    isLayerDisabled(layer: StaticLayerConfig): boolean {
        return !this.isLayerSelected(layer) && this.selectedLayers.length >= this.maxLayers
    }

    get filteredLayers(): StaticLayerConfig[] {
        const q = this.searchQuery.trim().toLowerCase()
        if (!q) return this.availableLayers
        return this.availableLayers.filter(l => (l.name ?? '').toLowerCase().includes(q))
    }

    canConfirm(): boolean {
        return this.selectedLayers.length > 0
    }

    confirm(): void {
        if (!this.canConfirm()) return
        this.dialogRef.close([...this.selectedLayers])
    }

    cancel(): void {
        this.dialogRef.close(null)
    }

    clear(): void {
        this.selectedLayers = []
    }
}
